import { Chip, Grid } from '@mui/material';
import { type FC } from 'react';

import { formatDateRange } from '../../utils';
import { useFehlerTypFilter } from './FehlerTypFilter';
import { useGeschaeftsbereichFilter } from './GeschaeftsbereichFilter';
import { useBeginFilterParams } from './hooks/useBeginFilterParams';
import { levelOptions, useLevelFilter } from './LevelFilter';

export const FilterChips: FC = () => {
  const [{ startDate, endDate }] = useBeginFilterParams();
  const [levelFilter, setLevelFilter] = useLevelFilter();
  const [geschaeftsbereichFilter, setGeschaeftsbereichFilter] = useGeschaeftsbereichFilter();
  const [fehlerTypFilter, setFehlerTypFilter] = useFehlerTypFilter();

  return (
    <Grid gap={1} container>
      {levelFilter.map((level) => (
        <Chip
          key={level}
          label={`Level: ${levelOptions.find((opt) => opt.value === level)?.label}`}
          variant="selection"
          color="secondary"
          onDelete={() => setLevelFilter(levelFilter.filter((l) => l !== level))}
        />
      ))}
      {geschaeftsbereichFilter.map((geschaeftsbereich) => (
        <Chip
          key={geschaeftsbereich}
          label={`Geschäftsbereich: ${geschaeftsbereich}`}
          variant="selection"
          color="secondary"
          onDelete={() => {
            setGeschaeftsbereichFilter(geschaeftsbereichFilter.filter((val) => val !== geschaeftsbereich));
          }}
        />
      ))}
      {fehlerTypFilter.map((fehlerTyp) => (
        <Chip
          key={fehlerTyp}
          label={`Fehler-Typ: ${fehlerTyp}`}
          variant="selection"
          color="secondary"
          onDelete={() => {
            setFehlerTypFilter(fehlerTypFilter.filter((val) => val !== fehlerTyp));
          }}
        />
      ))}
      <Chip
        // eslint-disable-next-line @eslint-react/purity -- added during migration to ban-pdk. please solve issue or explain disable-reason here
        label={`Veranstaltungbeginn: ${formatDateRange(startDate ?? new Date(), endDate, true)}`}
        variant="selection"
        color="secondary"
      />
    </Grid>
  );
};
